import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-remove-filter ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                <line x1="1.46488" y1="1.96444" x2="8.53595" y2="9.03551" stroke="black"/>
                <line x1="1.46481" y1="9.03555" x2="8.53587" y2="1.96448" stroke="black"/>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters ns-justify-content-end">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-selected-filter ns-d-flex ns-align-items-center"
                        >
                            <span class="ns-color-black">
                                {filter.name}: {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class="ns-anchor ns-clear-all"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear All
                </span>
            </div>
        )
    )
}
